import { c as _c } from "react/compiler-runtime";
import { ApiProfileRepRatesState } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function UserPageRepHeader(t0) {
  const $ = _c(13);
  const {
    repRates
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Rep:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== repRates) {
    t2 = repRates ? formatNumberWithCommas(repRates.total_rep_rating) : "";
    $[1] = repRates;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-text-base tw-font-medium tw-text-iron-300"><div className="tw-flex tw-items-center tw-space-x-1">{t1}<span className="tw-text-iron-50 tw-font-semibold">{t2}</span></div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>Raters:</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== repRates) {
    t5 = repRates ? formatNumberWithCommas(repRates.number_of_raters) : "";
    $[6] = repRates;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-text-base tw-font-medium tw-text-iron-300 tw-space-x-1">{t4}<span className="tw-text-iron-50 tw-font-semibold">{t5}</span></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div><div className="tw-mt-6 lg:tw-mt-8 tw-mb-4 lg:tw-flex lg:tw-items-center tw-lg:justify-between"><div className="tw-min-w-0 tw-flex-1"><div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-flex-wrap sm:tw-space-x-6 tw-gap-y-1">{t3}{t6}</div></div></div></div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}